import React from 'react'

import { connectHighlight } from 'react-instantsearch-dom';

const Snippet = ({ highlight, attribute, hit }) => {
  const parsedHit = highlight({
    highlightProperty: '_snippetResult',
    attribute,
    hit,
  });

  return (
    <span>
      {parsedHit.map(
        (part, index) => {
          let text = part.value.replace(/##/g, '');

          return part.isHighlighted ? (
            <em className="ais-Snippet-highlighted" key={index}>{text}</em>
          ) : (
            <span key={index}>{text}</span>
          )
        }
      )}
    </span>
  );
};

export default connectHighlight(Snippet);
